// Centralized constants for Chat service
const isYeshtery = process.env.REACT_APP_BUILD_YESHTERY === "true";
const devFallback = isYeshtery
  ? "https://api-yeshtery.dev.meetusvr.com/v1"
  : "https://api.dev.meetusvr.com";

export const API_BASE_URL = process.env.REACT_APP_RESTAPI || devFallback;
export const WS_BASE_URL = (process.env.REACT_APP_RESTAPI || devFallback).replace(/\/v1$/, "/ws");

export const STORAGE_KEYS = {
  accessToken: "X-User-Token",
  refreshToken: "X-Refresh-Token",
  userInfo: "chatUserInfo",
  chatId: "currentChatId",
};

const ApisConstants = {
  /** chat service endpoints - Updated endpoints */
  // chat-controller start
  getRooms: "/chat/rooms?isYeshtery=true",

  // message-controller start
  getMessagesHistory: "/message/by-chat",
  findMessage: "/message/find",

  // group chat endpoints
  getGroupRooms: "/social/group/channels",
  getGroupDetails: "/social/group", // + /{groupId}
  getGroupMessages: "/social/group/messages", // + /{groupId}?page=&size=
  joinGroup: "/social/group/join/channel", // POST ?groupId={id}

  // support agent endpoints (duty / queue / claim / release / roster)
  supportDuty: "/support/duty", // POST { onDuty }
  supportQueue: "/support/queue", // GET ?filter=needs_help|mine|unassigned|closed
  supportConversations: "/support/conversations", // POST /{chatId}/claim | /{chatId}/release
  supportAgents: "/support/agents", // GET roster | POST /{agentId}/duty (owner override)
};

export default ApisConstants;
